import React, { useEffect } from "react";
import {
  ContentMiddle,
  PageTitleComp,
  RightLayoutContainer,
} from "../../styledElements";
import { Button, PageHeader } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import LottieAnimation from "../../../Lottie";
import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
import Loader from "../../../Components/IconsFiles/loader"
import { useLocation, useNavigate } from "react-router";
import { getERPOrders } from "../../../Services/orderServices";
import axios from "axios";
export default function FetchingOrderScreen() {
  const location = useLocation()
  const history = useNavigate();
  useEffect(() => {
    const source = axios.CancelToken.source();
    
    const fetchData = async () => {
      try {
      const fetchType=await location?.state?.type;
      const data = await getERPOrders(source,fetchType);
      console.log(data);
      // if (data.error) {
      //   history("../order-records", {
      //     state: {
      //       action: 'erp_err',
      //       msg: data.msg,
      //     },
      //   });
      // } else {
      //   if (Object.keys(data?.data).length === 0) {
      //     history("../order-records", {
      //       state: {
      //         action: 'cancel',
      //         msg: "All ERP orders imported successfully",
      //       },
      //     });
      //   } else {
      //     history("../review-conflicting-orders", {
      //       state: {
      //         orderData: data?.data,
      //       },
      //     });
      //   }
      // }
      if (Object.keys(data?.data).length === 0) {
          history("../order-records", {
            state: {
              action: 'cancel',
              msg: "All ERP orders imported successfully",
            },
          });
        } else {
          history("../review-conflicting-orders", {
            state: {
              orderData: data?.data,
            },
          });
        }
    } catch (error) {
      console.log(error);
      history("../order-records", {
          state: {
            action: 'erp_err',
            msg: "Unable to fetch ERP orders",
          },
        });
    }
  };

  fetchData();

  return () => {
    source.cancel("Page is redirected");
  };
}, []);

  return (
    <RightLayoutContainer>
      <PageTitleComp style={{ borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          title="Fetching Orders"
          extra={[
            <Button
              key="1"
              className="textTypeBtn textBtnIcon"
              onClick={() => {
                history("../order-records");
              }}
            >
              {" "}
              <Iconmoon
                icon="wrong"
                size={14}
                color="#EA4E2C"
                style={{ marginRight: "8px", top: "1px", position: "relative" }}
              />{" "}
              Cancel Fetching Orders
            </Button>,
            // <Button
            //   key="1"
            //   className="themeBtn noBg noMargin"
            //   onClick={routeChange}
            // >
            //   Go Back
            // </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <ContentMiddle>
        <div className="imageAnimate">
          <div className="imageCover">
            <LottieAnimation lotti={JobcardPrepare} />
            <p>Please wait while orders getting fetched from ERP.</p>
          </div>
        </div>
      </ContentMiddle>
    </RightLayoutContainer>
  );
}
